import React from 'react';
import { Button } from '@/components/ui/button';
import { Phone, PhoneOff, Volume2, VolumeX, PhoneCall } from 'lucide-react';
import type { CallState } from '../types';

interface KeypadProps {
  handleCall: (event: React.MouseEvent) => void;
  handleEndCall: (event: React.MouseEvent) => void;
  handlePressKey: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleMicMute: () => void;
  handleHold: (sessionId: string, hold: boolean) => void;
  activeChannel: CallState;
  dialState: string;
  setDialState: (value: string) => void;
}

const keypadNumbers = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
  ['+', '0', '#']
];

export function Keypad({
  handleCall,
  handleEndCall,
  handlePressKey,
  handleMicMute,
  handleHold,
  activeChannel,
  dialState,
}: KeypadProps) {
  return (
    <div className="space-y-4">
      {/* Keypad Grid */}
      <div className="grid grid-cols-3 gap-3">
        {keypadNumbers.flat().map((digit) => (
          <Button
            key={digit}
            variant="outline"
            size="lg"
            value={digit}
            onClick={handlePressKey}
            className="h-12 text-lg font-semibold hover:bg-primary hover:text-primary-foreground transition-colors"
          >
            {digit}
          </Button>
        ))}
      </div>

      {/* Action Buttons */}
      <div className="flex justify-center space-x-4 pt-4">
        {!activeChannel.inCall ? (
          <Button
            onClick={handleCall}
            disabled={!dialState}
            size="lg"
            className="h-14 w-14 rounded-full bg-green-500 hover:bg-green-600 text-white"
          >
            <Phone className="h-6 w-6" />
          </Button>
        ) : (
          <>
            <Button
              onClick={handleEndCall}
              size="lg"
              className="h-14 w-14 rounded-full bg-red-500 hover:bg-red-600 text-white"
            >
              <PhoneOff className="h-6 w-6" />
            </Button>

            <Button
              onClick={handleMicMute}
              variant={activeChannel.muted ? "default" : "outline"}
              size="lg"
              className="h-14 w-14 rounded-full"
            >
              {activeChannel.muted ? <VolumeX className="h-6 w-6" /> : <Volume2 className="h-6 w-6" />}
            </Button>

            <Button
              onClick={() => handleHold(activeChannel.sessionId, activeChannel.hold)}
              variant={activeChannel.hold ? "default" : "outline"}
              size="lg"
              className="h-14 w-14 rounded-full"
            >
              <PhoneCall className="h-6 w-6" />
            </Button>
          </>
        )}
      </div>
    </div>
  );
}